module.exports = __webpack_public_path__ + "static/media/kapitalboost-logo.c7736d27.png";